module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av592-9b43976c8da3998dda97ce5122d42e28.jpg";